import resourceAdequacySlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const resourceAdequacyActions = { ...actions, ...thunkActions };
export * as RATypes from './types';
export default resourceAdequacySlice;
